import { useViewport } from 'contexts/viewport';
import { useTranslation } from 'react-i18next';
import { Button, FormLabel, Paper, Stack, styled, Switch, Text, ViewMore } from 'shell/components';
import { isFeedbackSettingsDefault } from 'utils/helper';

const StudentSection = ({ isEditable, form, setForm, errors, setStudentFeedbackSettingsDialog }) => {
    const { t } = useTranslation('assignment');
    const { device } = useViewport();

    const getText = () => {
        if (form.studentFeedbackSettings.structure === 'rubric') {
            return t(
                'feedback-section.rubric-based-feedback-with-feedbacktype',
                'Rubric-based feedback ({{feedbackType}})',
                {
                    feedbackType: isFeedbackSettingsDefault(form.studentFeedbackSettings)
                        ? t('system-default', 'System Default')
                        : t('edited', 'Edited'),
                }
            );
        }

        if (form.studentFeedbackSettings.structure === 'system') {
            return t('feedback-section.system-based-feedback', 'General & detailed feedback');
        }

        if (form.studentFeedbackSettings.structure === 'templated') {
            return errors.feedbackSettings
                ? t('feedback-section.templated-feedback-with-error', 'Smart Feedback Templates {{error}}', {
                      error: errors.feedbackSettings,
                  })
                : t('feedback-section.templated-feedback', 'Smart Feedback Templates');
        }

        return '';
    };

    return (
        <Stack sx={{ width: '100%' }} spacing={1}>
            <Text variant={'p1'}>Formative Feedback for Students</Text>
            <CustomPaper variant={'outlined'}>
                <Stack spacing={4}>
                    <CustomPaper variant={'outlined'}>
                        <Stack spacing={3}>
                            <Stack
                                alignItems={device === 'mobile' ? 'flex-start' : 'center'}
                                direction={'row'}
                                justifyContent={'space-between'}
                            >
                                <Text variant={'p1'}>Formative Feedback Settings</Text>
                                <Button
                                    disabled={!form.aiStudentFeedbackEnabled}
                                    variant={'borderless'}
                                    onClick={() => setStudentFeedbackSettingsDialog({ open: true })}
                                >
                                    Advanced Settings
                                </Button>
                            </Stack>
                            {form.studentFeedbackSettings.structure === 'custom' ? (
                                <ViewMore TextComponentProps={{ color: 'light', rich: true }}>
                                    {form.studentFeedbackSettings.customInstructions}
                                </ViewMore>
                            ) : (
                                <Text color={errors.feedbackSettings ? 'error' : 'light'} rich>
                                    {getText()}
                                </Text>
                            )}
                        </Stack>
                    </CustomPaper>
                    <Stack spacing={2}>
                        <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'} spacing={4}>
                            <FormLabel id={'feedback-switch'}>
                                <Text variant={'p1'}>Formative Feedback for Students</Text>
                            </FormLabel>
                            <Switch
                                aria-labelledby={'feedback-switch'}
                                checked={form.aiStudentFeedbackEnabled}
                                disabled={!isEditable}
                                onChange={(_, value) => {
                                    setForm((current) => ({ ...current, aiStudentFeedbackEnabled: value }));
                                }}
                            />
                        </Stack>
                        <Text>
                            Students can generate up to 3 rounds of AI feedback for assignments drafts before they
                            submit. When you enable instant feedback, students will be able to see the assignment
                            description and the assignment rubric.
                        </Text>
                    </Stack>
                </Stack>
            </CustomPaper>
        </Stack>
    );
};

const CustomPaper = styled(Paper)(({ theme }) => {
    return {
        padding: theme.spacing(4),
    };
});

export default StudentSection;
